module.exports = __webpack_public_path__ + "img/contractor_operation.555f4a23.jpg";